import 'client-only';

import { atom, useAtom } from 'jotai';
import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';

const navigatingAtom = atom(false);

export const useFlowProgressButtonState = (
  onClick?: () => Promise<void> | void,
) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const [loading, setLoading] = useState(false);
  const [navigating, setNavigating] = useAtom(navigatingAtom);

  useEffect(() => {
    setNavigating(false);
  }, [pathname, searchParams, setNavigating]);

  const handleClick = () => {
    setLoading(true);
    setNavigating(true);
    onClick?.();
  };

  return {
    onClick: handleClick,
    loading,
    disabled: !loading && navigating,
  };
};
